require('../../modules/es7.object.values');
module.exports = require('../../modules/$.core').Object.values;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/object/values.js
// module id = 703
// module chunks = 0